import axios from "axios";
import { apiURL } from "../config";
import Cookies from "js-cookie";

export const drawTicketApi = async (address) => {
  try {
    const response = await axios.get(
      `${apiURL}/draw-tickets?address=${address}`
    );
    if (response && response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Axios Error:", error);
  }
};

export const fetchDrawList = async () => {
  try {
    const response = await axios.get(`${apiURL}/draws`);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Axios Error:", error);
  }
};

export const fetchDrawDetailsApi = async (drawId) => {
  const response = await axios.get(`${apiURL}/draw-details/${drawId}`);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return [];
  }
};
export const winnersData = async (address = null, drawId = null) => {
  let sUrl = "";
  if (address && drawId) {
    sUrl = `?address=${address}&drawId=${drawId}`;
  } else if (address) {
    sUrl = `?address=${address}`;
  } else if (drawId) {
    sUrl = `?drawId=${drawId}`;
  }
  const response = await axios.get(`${apiURL}/draw-winners${sUrl}`);
  return response.data;
};
export const fetchDrawListFoWinners = async () => {
  try {
    const response = await axios.get(`${apiURL}/draw-for-winners`);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Axios Error:", error);
  }
};

export const fetchTransactionData = async () => {
  try {
    const address = Cookies.get("connectedAddress");
    const response = await axios.get(`${apiURL}/transactions/${address}`);
    return response ? response?.data : null;
  } catch (error) {
    console.log("Error fetching transactions:", error);
  }
};

export const fetchReferralsList = async () => {
  try {
    const address = Cookies.get("connectedAddress");
    const response = await axios.get(`${apiURL}/referrals/${address}`);
    return response ? response?.data : null;
  } catch (error) {
    console.log("Error fetching referrals:", error);
  }
};
export const fetchProfile = async () => {
  try {
    const address = Cookies.get("connectedAddress");
    const response = await axios.get(`${apiURL}/user/${address}`);
    console.log("Fetch Profile Response: 11 ", response.status);

    if (response && response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error?.response?.status === 404) {
      return {
        status: 404,
        data: error?.response?.data,
      };
    }
    console.log("Error fetching profile:", error);
  }
};

export const createUpdateProfile = async (body) => {
  try {
    const address = Cookies.get("connectedAddress");
    const response = await axios.post(`${apiURL}/user/${address}`, body);
    if (response && response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log("Error createUpdateProfile profile:", error);
  }
};

export const fetchUserList = async () => {
  try {
    const response = await axios.get(`${apiURL}/users-list`);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Axios Error:", error);
  }
};
